<template>
<v-container fluid>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">
        Servicios
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              icon
              color="primary"
              class="px-0"        
              v-bind="attrs"
              v-on="on" 
              @click="obtenerServicios"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refrescar información de la tabla</span>
        </v-tooltip>
      </div>
      <div class="flex-grow-1">
        <dialog-form-servicio v-if="permisoAdmin||permisoCoordinador" name="dfs_0" :id-accion="1" :fn-on-save="obtenerServicios"></dialog-form-servicio>
      </div>      
      <div class="flex-grow-1">
        <v-row justify="end">
          <v-col 
            cols="12" 
            sm="5"
          >
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              hide-details
              outlined
              dense
            />
          </v-col>
        </v-row>
      </div>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        calculate-widths
        loading-text="Cargando... Por favor espere"
        locale="es-ES"
      >
        <template v-slot:item.habilitado="{ item }">
          <v-icon :color="item.habilitado ? 'green' : 'red'">
            {{ item.habilitado ? 'mdi-check' : 'mdi-close' }}
          </v-icon>
        </template>
        <template v-slot:item.encuestas="{ item }">
          <v-avatar
            color="indigo"
            size="25"
          >
            <span class="white--text text-h6">{{item.eiEncuesta.length}}</span>
          </v-avatar>
        </template>
        <template v-slot:item.acciones="{ item }">
          <dialog-responsables :obj-servicio="item"></dialog-responsables>
          <dialog-form-servicio v-if="permisoAdmin||permisoCoordinador" :name="'dfs_' + item.idCatServicio" :id-accion="2" :obj-servicio="item" :fn-on-save="obtenerServicios"></dialog-form-servicio>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
  <v-snackbar
    key="snackbarDataTableServicios"
    v-model="snackbar"
    :bottom="true"
    :multi-line="true"
    :color="snackbarColor"
  >
    {{ snackbarTexto }}
    <v-btn dark text @click="snackbar = false;">
      Cerrar
    </v-btn>
  </v-snackbar> 
</v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { getServicios } from "@/api";

export default {
  name: "DataTableServicios",
  components: {
    DialogResponsables: () => import("../bandejaServicios/DialogResponsables"),
    DialogFormServicio: () => import("../bandejaServicios/DialogFormServicio"),
  },
  props: {
    flagReload: {
      type: Number,
      default: 0
    },
    fnOnLoaded: {
      type: Function,
      default: () => {}
    },
  },
  data () {
    return {
      loading: true,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',
      headers: [
        { align: "left", text: "Nombre Servicio", value: "nombreServicio" },
        { align: "left", text: "Campus", value: "campus" },
        { align: "left", text: "División", value: "division" },
        { align: "left", text: "Departamento / Plan Unidad", value: "depPlanUnidad" },
        { align: "left", text: "Clasif. Proceso", value: "clasificacionProceso" },
        { align: "left", text: "Clave proceso", value: "claveProceso" },
        { align: "left", text: "Nombre proceso", value: "nombreProceso" },
        { align: "center", text: "Habilitado", value: "habilitado" },
        { align: "center", text: "Núm. Encuestas", value: "encuestas" },
        { align: "center", text: "Acciones", value: "acciones" }
      ],
      items: [],
      itemsFilter: [],
      search: "",
      dialog: false,
      itemSelected: {},
      permisoAdmin: false,
      permisoCoordinador: false
    };
  },
  computed: { },
  watch: {
    flagReload: {
      handler (newValue, oldValue) {
        this.obtenerServicios();
			},
    },
  },
  async mounted () {
    this.permisoAdmin = await this.tienePermisoServicio({permiso: 'Administrador Encuestas'});
     this.permisoCoordinador = await this.tienePermisoServicio({permiso: 'Coordinador'});
    this.obtenerServicios();
  },
  methods: {
    ...mapActions(['tienePermisoServicio']),
    async obtenerServicios () {
      var self = this;
      self.loading = true;
      self.items = [];
      self.itemsFilter = [];
      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getServicios();

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.items = response.data.data;
              self.loading = false;
              //self.filtrarItems();
            }
          } else {
            self.snackbarTexto = "DataTableServicios: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableServicios: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableServicios: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
  }
};
</script>
